module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"add-shared-success":"La recette a été ajoutée avec succès, vous allez être redirigé vers la page d\u0027accueil.","add-shared-error":"Erreur lors de l\u0027ajout de la recette, veuillez réessayer."},"en":{"add-shared-success":"The recipe has been added successfully, you will be redirected to the home page.","add-shared-error":"Error adding recipe, please try again."}}')
  delete Component.options._Ctor
}
